<script>
import * as m from '@app/paraglide/messages.js';
  /** @type {{text: any, fontFamily: any}} */
  let { text, fontFamily, fontSize } = $props();
</script>

<div id="originalTextPreview"
  role="region"
  aria-label={m.event_original_text_preview_aria_label()}
  class="text-white bg-dark bg-opacity-50 text-center p-2 EditorPreviewText rounded"
  style="font-family: {fontFamily} !important; font-size: {fontSize}px !important;">
    {@html text}
</div>
<style lang="css">
.EditorPreviewText {
    height: 160px;
    overflow-y: auto;
    overflow-x: hidden;
}    
</style>